import React from 'react';

const TRUST_ICON_PATH = 'https://i.diplomaframe.com/images/cached/general';

/** The redesign's three trust rows (fast shipping, returns, licensing), shared by the order summary and the empty cart. */
export const TrustList = ({className}: {className: string}) => (
    <ul className={className}>
        <li>
            <span className="ab-trust-icon">
                <img
                    width={27}
                    height={21}
                    loading="lazy"
                    src={`${TRUST_ICON_PATH}/fast_ship_small_icon.svg`}
                    alt="Icon of a delivery truck representing fast shipping"
                />
            </span>
            <span>Fast shipping within 8-10 business days</span>
        </li>
        <li>
            <span className="ab-trust-icon">
                <img
                    width={27}
                    height={27}
                    loading="lazy"
                    src={`${TRUST_ICON_PATH}/easy_returns_small_icon.svg`}
                    alt="Circular arrow icon representing 120-day return policy"
                />
            </span>
            <span>Guaranteed 120-day returns</span>
        </li>
        <li>
            <span className="ab-trust-icon">
                <img
                    width={27}
                    height={27}
                    loading="lazy"
                    src={`${TRUST_ICON_PATH}/certificate_small_icon.svg`}
                    alt="Badge icon denoting officially licensed frames"
                />
            </span>
            <span>Officially licensed by colleges &amp; universities</span>
        </li>
    </ul>
);

export default TrustList;
